var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("哎，页面出错了")]),_vm._v(" "),_c('div',{staticClass:"back",on:{"click":_vm.getToBack}},[_vm._v("返回上一页")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610a6970","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error-page/404.vue
// module id = null
// module chunks = 